// Embla Carousel - Global implementation for Shopify theme
// CDN version for easy integration

(function() {
  'use strict';

  // Load Embla Carousel from CDN
  function loadEmbla() {
    return new Promise((resolve, reject) => {
      if (window.EmblaCarousel) {
        resolve(window.EmblaCarousel);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://unpkg.com/embla-carousel/embla-carousel.umd.js';
      script.onload = () => resolve(window.EmblaCarousel);
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  // Global carousel manager
  window.CollexableCarousel = {
    instances: new Map(),
    
    // Initialize a carousel
    init: function(container, options = {}) {
      if (!container) return null;
      
      const defaultOptions = {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
        ...options
      };
      
      return loadEmbla().then(EmblaCarousel => {
        const embla = EmblaCarousel(container, defaultOptions);
        const id = Math.random().toString(36).substr(2, 9);
        
        this.instances.set(id, embla);
        
        // Add scrollbar functionality
        this.addScrollbar(embla, container);
        
        // Add navigation buttons if requested
        if (options.navigation) {
          this.addNavigation(embla, container, options.navigation);
        }
        
        return { id, embla };
      });
    },
    
    // Add scrollbar to carousel
    addScrollbar: function(embla, container) {
      const scrollbar = container.querySelector('[data-scrollbar]');
      const scrollbarThumb = container.querySelector('[data-scrollbar-thumb]');
      
      if (!scrollbar || !scrollbarThumb) {
        console.log('Scrollbar elements not found:', { scrollbar, scrollbarThumb });
        return;
      }
      
      const updateScrollbar = () => {
        // Use scroll progress for smooth movement (0 = leftmost, 1 = rightmost)
        const scrollProgress = embla.scrollProgress();
        
        // Position the thumb (fixed width, moves left/right)
        const thumbWidth = 25; // Fixed 25% width
        const maxThumbPosition = 100 - thumbWidth; // How far right the thumb can go
        const thumbPosition = scrollProgress * maxThumbPosition;
        
        scrollbarThumb.style.width = thumbWidth + '%';
        scrollbarThumb.style.marginLeft = thumbPosition + '%';
        
        // Debug info
        console.log('Scrollbar updated:', { scrollProgress, thumbPosition });
      };
      
      // Initialize scrollbar
      embla.on('init', updateScrollbar);
      embla.on('reInit', updateScrollbar);
      embla.on('scroll', updateScrollbar);
      
      // Initial update
      setTimeout(updateScrollbar, 100);
      
      // Click on scrollbar to navigate
      scrollbar.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const rect = scrollbar.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const scrollbarWidth = rect.width;
        const scrollRatio = clickX / scrollbarWidth;
        
        const maxScroll = embla.scrollSnapList().length - 1;
        const targetIndex = Math.round(scrollRatio * maxScroll);
        
        console.log('Scrollbar clicked:', { clickX, scrollRatio, targetIndex, maxScroll });
        embla.scrollTo(targetIndex);
      });
    
    },
    
    // Add navigation buttons
    addNavigation: function(embla, container, navigationOptions) {
      const { prevButton, nextButton } = navigationOptions;
      
      if (prevButton) {
        prevButton.addEventListener('click', () => embla.scrollPrev());
      }
      
      if (nextButton) {
        nextButton.addEventListener('click', () => embla.scrollNext());
      }
      
      // Update button states
      const updateButtons = () => {
        if (prevButton) {
          prevButton.disabled = !embla.canScrollPrev();
        }
        if (nextButton) {
          nextButton.disabled = !embla.canScrollNext();
        }
      };
      
      embla.on('select', updateButtons);
      embla.on('init', updateButtons);
      embla.on('reInit', updateButtons);
      updateButtons();
    },
    
    // Destroy a carousel instance
    destroy: function(id) {
      const instance = this.instances.get(id);
      if (instance) {
        instance.destroy();
        this.instances.delete(id);
      }
    },
    
    // Destroy all carousels
    destroyAll: function() {
      this.instances.forEach(embla => embla.destroy());
      this.instances.clear();
    }
  };

  // Auto-initialize carousels with data-embla attribute
  function initializeCarousels() {
    console.log('Initializing carousels...');
    const carousels = document.querySelectorAll('[data-embla]');
    console.log('Found carousels:', carousels.length);
    
    carousels.forEach((container, index) => {
      console.log(`Initializing carousel ${index + 1}:`, container);
      const options = JSON.parse(container.dataset.embla || '{}');
      console.log('Carousel options:', options);
      
      window.CollexableCarousel.init(container, options).then(result => {
        if (result) {
          console.log(`Carousel ${index + 1} initialized successfully:`, result.id);
        }
      }).catch(error => {
        console.error(`Failed to initialize carousel ${index + 1}:`, error);
      });
    });
  }
  
  // Try multiple initialization methods
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCarousels);
  } else {
    // DOM already loaded
    initializeCarousels();
  }
  
  // Fallback for Shopify sections that load after DOM
  if (typeof window.Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', initializeCarousels);
  }

})();
